import type { Essentials } from '@wix/fe-essentials/core';

export type MonitorLogger = Pick<
  Essentials['fedopsLogger'],
  'interactionStarted' | 'interactionEnded' | 'reportErrorThrownOncePerFlow'
>;
